import Feature from '@js/plugins/feature';
import moment from 'moment';

class Auth {
    canAccessAllOutlets() {
        return this.outlets().length === 0;
    }

    canExtendAccount() {
        return Feature.hasFeature('extend_account');
    }

    hasAnyPermission(...permissions) {
        if (Array.isArray(permissions[0])) {
            permissions = permissions[0];
        }

        for (var permission of permissions) {
            if (this.hasPermissionTo(permission)) {
                return true;
            }
        }

        return false;
    }

    hasPermissionTo(permission) {
        let permissions = _.get(window.slurp, 'auth.user.permissions', []);
        return _.includes(permissions, permission);
    }

    hasSubscription() {
        let subscription = _.get(
            window.slurp,
            'auth.franchise.subscription',
            null,
        );

        return subscription != null && subscription.id != null;
    }

    franchise() {
        let franchise = _.get(window.slurp, 'auth.franchise');

        return franchise;
    }

    outlets() {
        return _.get(window.slurp, 'auth.user.outlets', []);
    }

    user() {
        let user = _.get(window.slurp, 'auth.user');
        user.last_login = moment(user.last_login);

        return user;
    }

    isOutletManager() {
        return !!_.get(window.slurp, 'auth.user.is_outlet_manager', false);
    }

    isFranchiseManager() {
        return !!_.get(window.slurp, 'auth.user.is_franchise_manager', false);
    }
}

const AuthInstance = new Auth();

export default AuthInstance;



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/auth.js